document.addEventListener('DOMContentLoaded', function () {
    const form = document.getElementById('wholesale-order-form');
    const quantityInputs = document.querySelectorAll('.quantity');
    const totalPriceElement = document.getElementById('total-price');
    const orderBodyField = document.getElementById('order-body');

    function updateTotals() {
        let total = 0;

        quantityInputs.forEach(input => {
            let quantity = parseInt(input.value) || 0;
            let price = parseFloat(input.dataset.price) / 100; // Convert cents to dollars
            let variantId = input.closest("tr").querySelector(".subtotal").id.replace("subtotal-", "");
            let subtotalElement = document.getElementById(`subtotal-${variantId}`);

            let subtotal = quantity * price;
            subtotalElement.innerText = `$${subtotal.toFixed(2)}`;
            total += subtotal;
        });

        totalPriceElement.innerText = `$${total.toFixed(2)}`;
    }

    quantityInputs.forEach(input => {
        input.addEventListener('input', updateTotals);
    });

    form.addEventListener('submit', function (event) {
        event.preventDefault(); // Prevent default form submission

        let orderItems = [];
        let total = 0;
        let email = document.getElementById('email').value;
        let leadTime = document.getElementById('lead-time').value;
        let orderNotes = document.getElementById('order-notes').value.trim();

        quantityInputs.forEach(input => {
            let quantity = parseInt(input.value) || 0;
            let productName = input.dataset.productName;
            let variantName = input.dataset.variantName;
            let wholesalePrice = parseFloat(input.dataset.price) / 100;
            let retailPrice = wholesalePrice * 2;
            let notesInput = input.closest("tr").querySelector(".notes");
            let notes = notesInput ? notesInput.value.trim() : "";
            let subtotal = quantity * wholesalePrice;
            total += subtotal;

            if (quantity > 0) {
                orderItems.push(
                    `<p><strong>Product:</strong> ${productName} - ${variantName}</p>\n` +
                    `<p><strong>Retail Price:</strong> <s>$${retailPrice.toFixed(2)}</s></p>\n` +
                    `<p><strong>Wholesale Price:</strong> $${wholesalePrice.toFixed(2)}</p>\n` +
                    `<p><strong>Quantity:</strong> ${quantity}</p>\n` +
                    `<p><strong>Subtotal:</strong> $${subtotal.toFixed(2)}</p>\n` +
                    `<p><strong>Notes:</strong> ${notes || "None"}</p>\n<hr>\n`
                );
            }
        });

        if (orderItems.length === 0) {
            document.getElementById('order-response').innerText = "Please select at least one product.";
            return;
        }

        let formattedEmailBody = `<h2>New Wholesale Order Request</h2>\n` +
              `<p><strong>Email:</strong> ${email}</p>\n` +
              `<p><strong>Lead Time Request:</strong> ${leadTime}</p>\n` +
              `<h3>Products Ordered:</h3>\n\n` + 
              orderItems.join("\n") +
              `<h3>Total Order Price: $${total.toFixed(2)}</h3>\n` +
              `<p><strong>Order Notes:</strong> ${orderNotes || "None"}</p>\n`;

        orderBodyField.value = formattedEmailBody; // Inject formatted order into hidden field

        // Send email to you
        fetch('/contact', {
            method: 'POST',
            body: new FormData(form)
        }).then(response => {
            if (response.ok) {
                document.getElementById('order-response').innerText = "Order request submitted! You will receive a confirmation email shortly.";
            } else {
                document.getElementById('order-response').innerText = "There was an issue submitting your order. Please try again.";
            }
        });
    });
});
